export default __webpack_public_path__ + "static/media/Chrysalis.591087bd.png";